<template>
  <base-card
    no-padding
    :title="EntityCardMixin_Title"
  >
    <base-list-overview
      controller="Activity"
      custom-create
      custom-update
      :filter="Filter"
      inside-card
      :readonly="EntityCardMixin_Readonly"
      :visible="ShowOverview"
      @custom-create="$emit('create')"
      @custom-update="$emit('update', $event)"
    />
  </base-card>
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'EntityCardActivitiesOverview',
  components: {
    BaseListOverview
  },
  mixins: [
    EntityCardMixin
  ],
  data () {
    return {
      copy: null,
      initialized: false,
      showOverview: true
    }
  },
  watch: {
    async Filter () {
      await this.SetCopy()
    }
  },
  computed: {
    Filter () {
      const key = 'idCarePartner'
      return [
        {
          key: key,
          value: this.EntityCardMixin_CopySource?.idCarePartner ?? this.constantMixin.guid.empty
        }
      ]
    },
    ShowOverview () {
      return this.visible && this.showOverview
    }
  },
  async mounted () {
    await this.Initialize()
  },
  methods: {
    async Initialize () {
      this.EntityCardMixin_SetDefaultTitle('activities')
      await this.SetCopy()
    },
    SelectionChanged (value) {
      if (this.initialized) {
        this.EntityCardMixin_CopySource.activities.items = value
      } else {
        this.initialized = true
      }
    },
    async SetCopy () {
      this.showOverview = false
      this.copy = this.CommonMixin_Clone(this.value)
      this.showOverview = true
      this.$forceUpdate()
    }
  }
}
</script>
